import { Grid, makeStyles } from "@material-ui/core";
import { Tabs } from "@ofqual/portal-components/components/Tabs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadingUser } from "../redux/actions";
import { authSelector, userSelector } from "../redux/selectors";
import { UserForm } from "./UserForm";
import { ScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";
import {
  LinkedRecords,
  LinkedRecordType,
} from "@ofqual/portal-linked-records/linked-records";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserType } from "../redux/types";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const User: React.FC = () => {
  const classes = useStyles();
  const { upn } = useParams<{ upn: string }>();
  const userState = useSelector(userSelector);
  const { userType } = useAuth(authSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadingUser(upn));
  }, [dispatch, upn]);

  const isOfqualUser = userType === UserType.Ofqual;

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item md={isOfqualUser ? 8 : 12}>
          <Tabs
            currentTabId=""
            onTabChange={() => {}}
            tabs={[{ id: "", label: "User Details" }]}
          />
          <UserForm userState={userState} />
        </Grid>
        {isOfqualUser ? (
          <Grid item md={4} xs={12}>
            <ScrollableAreaTabs
              tabs={[
                {
                  label: "Linked Records",
                  content: (
                    <LinkedRecords
                      entityReferenceId={upn}
                      entityTitle={upn}
                      entityLinkedRecordType={LinkedRecordType.user}
                    />
                  ),
                  tabTypeId: "linkedRecords",
                },
              ]}
            ></ScrollableAreaTabs>
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};
